module.exports = __webpack_public_path__ + "media/images/icon-chart-up-green-7046ed62d59a337d61e105c56015c53f.svg";